<template>
  <div class="mobile-navigation show-on-mobile-flex">
    <div>
      <v-btn x-large class="bg-transparent" block to="/MyMemories"
        ><v-icon>mdi-home-outline</v-icon></v-btn
      >
    </div>
    <div>
      <v-btn x-large class="bg-transparent" block to="/MemoriesWall"
        ><v-icon>mdi-wall</v-icon></v-btn
      >
    </div>
    <div>
      <v-btn x-large class="bg-transparent" block to="/AddMemories"
        ><v-icon>mdi-account-plus-outline</v-icon></v-btn
      >
    </div>
    <div>
      <v-btn x-large class="bg-transparent" block to="/PendingRequests"
        ><v-icon>mdi-account-group-outline</v-icon></v-btn
      >
    </div>
    <div>
      <v-btn x-large class="bg-transparent" block to="/Bookmarks"
        ><v-icon>mdi-bookmark-outline</v-icon></v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileNavigationTop",
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>